import { Layout } from 'antd';

const Divider = () => {
  return <span style={{ margin: '0 0.5rem' }}>|</span>;
};

export function ExternalFooter() {
  return (
    <Layout.Footer style={{ margin: 'auto', paddingTop: 10, paddingBottom: 10 }}>
      Intel and the Intel logo are trademarks of Intel Corporation or its subsidiaries
      <Divider />
      <a
        href="https://circuit.intel.com/content/corp/Global_Employee_and_Global_Contingent_Worker_Privacy.html"
        target="_blank"
        rel="noreferrer"
      >
        Employee/Contingent Worker Privacy
      </a>
      <Divider />
      <a href="https://www.intel.com/privacy" target="_blank" rel="noreferrer">
        Privacy Notice
      </a>
      <Divider />
      <a href="https://www.intel.com/cookies" target="_blank" rel="noreferrer">
        Cookies Notice
      </a>
      <Divider />
      Intel Confidential
      <Divider />© Intel Corporation
    </Layout.Footer>
  );
}
